import { mkdir, writeFile } from "node:fs/promises";
import path from "node:path";
import { fileExists } from "./file-exists";

export async function writeFileSafe(filePath: string, contents: string): Promise<"created" | "skipped"> {
  await mkdir(path.dirname(filePath), { recursive: true });

  if (await fileExists(filePath)) {
    return "skipped";
  }

  await writeFile(filePath, contents, "utf8");
  return "created";
}
